import { render, staticRenderFns } from "./CancellationView.vue?vue&type=template&id=36787afc&scoped=true"
import script from "./CancellationView.vue?vue&type=script&lang=ts"
export * from "./CancellationView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36787afc",
  null
  
)

export default component.exports